import { URLS } from '@/data/config';
import { createActiveCashWalletHeaders } from '@/hooks/use-active-wallet';
import { useMutation } from '@tanstack/react-query';

import { WithdrawBodyProps } from '../types';

/**
 * Custom react query mutation hook to withdraw amount to a specific method
 * POST /auth/wallet/withdraw
 * @returns {Object} - react-query mutation object
 */
export const useWithdrawAmount = () => {
    return useMutation({
        mutationFn: (withdrawBody: WithdrawBodyProps) => {
            const { amount, type, currency, payment_type_id } = withdrawBody;
            const body = new URLSearchParams();
            body.append('amount', amount);
            body.append('type', type);
            body.append('currency', currency);
            body.append('payment_type_id', payment_type_id);

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...createActiveCashWalletHeaders(),
            };

            return fetch(`${URLS.CHAMELON_API_URL}/auth/wallet/withdraw`, {
                method: 'POST',
                headers,
                body: body.toString(),
            });
        },
    });
};
